module.exports = __webpack_public_path__ + "static/media/slider_study_2.dbb392f1.jpg";